/**
 * record.js
 */

import { parseISO } from 'date-fns';
import { Types } from 'utils/constants';
import { getAttendance } from 'utils/event-attendance';


const exerciseCompletionChipStatus = (
  roleId, 
  isFuture, 
  attendance, 
  numActiveDogs, 
  numOutdated, 
  numComplete, 
  numIncomplete, 
  forceDetailCount
) => {
  let id = ''
  let label = '';
  const showDetailCount = 
    forceDetailCount
    || (roleId === Types.Role.HANDLER && numActiveDogs > 1) 
    || roleId === Types.Role.SUPERVISOR;
  
  if (attendance && attendance?.id !== Types.Attendance.ATTENDING) {
    id = attendance?.id;
    label = `${showDetailCount ? `${numIncomplete} ` : ''}${attendance?.label}`;
  } else if (isFuture) {
    id = 'upcoming';
    label = `${showDetailCount ? `${numIncomplete} ` : ''}Upcoming`;
  } else if (numOutdated > 0) {
    id = 'outdated';
    label = `${showDetailCount ? `${numComplete}/${numComplete + numIncomplete} ` : ''}Complete`;
  } else if (numIncomplete === 0) {
    id = 'complete';
    label = `${showDetailCount ? `${numComplete}/${numComplete + numIncomplete} ` : ''}Complete`;
  } else {
    id = 'incomplete';
    label = `${showDetailCount ? `${numComplete}/${numComplete + numIncomplete} ` : ''}`
      + `${showDetailCount ? 'Complete' : 'Incomplete'}`;
  }
  
  return {
    id,
    label,
    numIncomplete,
    numComplete,
  };
};


export const handlerExerciseCompletionStatus = (numComplete, numIncomplete, numOutdated, event, handlerId, numActiveDogs, forceDetailCount) => {
  const membership = handlerId
    ? event.members.find(m => m.id === handlerId)
    : event.membership;
  const attendance = getAttendance(membership?.isOptional, membership?.isAttending);

  return exerciseCompletionChipStatus(
    Types.Role.HANDLER,
    parseISO(event.date) > new Date(),
    attendance,
    numActiveDogs,
    numOutdated,
    numComplete,
    numIncomplete,
    forceDetailCount
  );
}


export const supervisorExerciseCompletionStatus = (numComplete, numIncomplete, eventDate) => {
  return exerciseCompletionChipStatus(
    Types.Role.SUPERVISOR,
    parseISO(eventDate) > new Date(),
    null,
    null,
    0,
    numComplete,
    numIncomplete
  );
}


export const supervisorReviewStatus = ({notReviewed, accepted, rejected}) => {
  const total = notReviewed + accepted + rejected;
  const reviewed = accepted + rejected;
  return (total === 0)
    ? null
    : {
      id: notReviewed === 0 ? 'reviewed' : 'not-reviewed',
      label: `${reviewed}/${total} Reviewed`,
    };
}